import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { sseClient } from '#pplx_generated/typespec/rest/sse/client.js';
export const postPerplexityConnectorAuthResponse = async ({ uuid, success, reason, }) => {
    try {
        const { data, error, response } = await sseClient.POST('/rest/sse/perplexity_connector_auth_response', reason, {
            body: {
                result: {
                    tool_uuid: uuid,
                    success,
                },
            },
            backOffTime: 100,
            numRetries: 1,
            headers: {
                'Content-Type': 'application/json',
            },
        });
        if (data?.status !== 'success') {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                message: 'Failed to post perplexity connector auth response',
                cause: error,
                status: response.status ?? 0,
            });
        }
        return true;
    }
    catch (err) {
        logger.error('Failed to post perplexity connector auth response', err);
        return false;
    }
};
//# sourceMappingURL=postPerplexityConnectorAuthResponse.js.map